export default __webpack_public_path__ + "static/media/secure.864bd8fa.svg";